<template>
    <auth-layout title="Réinitialisation de mot de passe">
        <div>
            <div class="mb-4 text-sm text-gray-600 w-[450px]">
                Mot de passe oublié? Aucun problème. Indiquez-nous simplement votre adresse mail
                et nous vous enverrons par mail un lien de réinitialisation de mot de passe qui vous permettra d'en choisir un nouveau.
            </div>

            <JetValidationErrors class="mb-4" />

            <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                {{ status }}
            </div>
        </div>
        <form @submit.prevent="submit">
            <div class="space-y-4">
                <div>
                    <JetLabel for="email" value="Adresse mail:" />
                    <JetInput id="email" type="email" autocomplete="off"
                        v-model="form.email" placeholder="Entrer votre adresse mail"
                    />
                </div>
            </div>
            <div class="flex items-center justify-between mt-4">
                <Link  :href="route('login')"
                    class="text-sm underline hover:no-underline text-greendack-500 hover:text-greendack-400"
                >
                    J'ai retrouvé mon mot de passe !
                </Link>
                <BotiButton :loader="form.processing" :disabled="form.processing"
                    @click="submit"  color="greendack"
                    :class="{ 'opacity-25': form.processing }" text="Envoyer"
                >
                    <svg v-if="form.processing" class="animate-spin w-4 h-4 fill-current shrink-0" viewBox="0 0 16 16">
                        <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"></path>
                    </svg>
                    <template #icon>
                        <i class="fad fa-paper-plane ml-1"></i>
                    </template>
                </BotiButton>
            </div>
        </form>
    </auth-layout>
</template>

<script>
    import { defineComponent } from 'vue'
    import BotiButton from '@/Components/Button'
    import JetInput from '@/Jetstream/Input.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import { Link } from '@inertiajs/inertia-vue3'
    import AuthLayout from '@/Layouts/AuthLayout.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'

    export default defineComponent({
        components: {
            Link,
            JetInput,
            JetLabel,
            AuthLayout,
            BotiButton,
            JetValidationErrors
        },

        props: {
            status: String
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: ''
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.email'))
            }
        }
    })
</script>
